export default {"src":"/login-app/[GIT_HASH]/_next/static/media/blueprint.59f9486f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};